import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './FilterFormConstants';
import FilterFormSkeletonNodeLayout from './FilterFormSkeletonNodeLayout';
import PrimaryFilterFormSkeleton from './PrimaryFilterFormSkeleton';
import SecondaryFilterFormSkeleton from './SecondaryFilterFormSkeleton';
import withDebouncing from './withDebouncing';
export interface TextAreaFilterForm extends BaseFilterFormProps {
  filterStyle: FilterStyle;
  onChangeValue: (value: string) => void;
  onRemove?: () => void;
  placeholder: string;
  value: string;
}

function TextAreaFilterForm(props: TextAreaFilterForm): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const textarea = (
    <textarea
      className={css(styles.textarea)}
      onChange={(e) => {
        props.onChangeValue(e.target.value);
      }}
      placeholder={props.placeholder}
      value={props.value}
    />
  );
  if (props.filterStyle === FilterStyle.PRIMARY) {
    return (
      <PrimaryFilterFormSkeleton
        {...skeletonProps}
        content={<FilterFormSkeletonNodeLayout nodeGrid={[[textarea]]} />}
        dropdownToggleText={props.dropdownToggleText}
      />
    );
  } else {
    if (!props.onRemove) {
      throw new Error('Expected props.onRemove to be present when filterStyle is SECONDARY');
    }
    return (
      <SecondaryFilterFormSkeleton
        {...skeletonProps}
        nodeGrid={[[textarea]]}
        onChangeFilterKey={props.onChangeFilterKey}
        selectedFilterKey={props.selectedFilterKey}
        onRemove={props.onRemove}
      />
    );
  }
}
export default withDebouncing(TextAreaFilterForm);

const styles = StyleSheet.create({
  textarea: {
    resize: 'vertical',
  },
});
